module.exports = __webpack_public_path__ + "img/TextoSubHeader.516bc0b0.png";